/*@flow*/
import downloadURL from 'lib/downloadURL';

type PropsT = {
  fileName: string,
  data: string,
};

export default ({ fileName, data }: PropsT) => {
  let svgBlob = new Blob([data], { type: 'image/svg+xml;charset=utf-8' });
  const url = URL.createObjectURL(svgBlob);
  downloadURL({ url, fileName });
};
